//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import parse from 'date-fns/parse'
//import format from 'date-fns/format'

export default {
  props: {
    block: {
      type: Object,
      default: null
    }
  },
  components: {

  },
  computed: {
    activeVenues() {
      return this.block.slides[this.ui.currentSlide].venues
    }
  },
  watch: {

  },
  filters: {

  },
  data() {
    return { 
      
      loading: true,
      ui: {
        currentSlide: 0,
        currentVenue: 0
      },
      
    }
  },
  mounted() {

console.log('THE BLOCK', this.block)


console.log('REFS', this.$refs)
 

  },
  methods: {

    slideChanged: function ($event) {

      this.ui.currentSlide = $event.currentSlide.index
      this.ui.currentVenue = 0
      console.log('$event', $event)
        console.log('REFS', this.$refs)
      this.$refs.slideVenueNavs.goToSlide($event.currentSlide.index, { emit: false })

      
    },
    setVenueSlide(slide, venue) {

      this.$refs['venueNav_'+slide].forEach( (vRef) => {
        vRef.goToSlide( venue )
      })

    },
    nextVenueThumb(slide) {
      //this.$refs.venueNav.next()

      this.$refs['venueNav_'+slide].forEach( (vRef) => {
        vRef.next()
      })
    },
    prevVenueThumb(slide) {
      this.$refs['venueNav_'+slide].forEach( (vRef) => {
        vRef.previous()
      })
    },
    debugEvent($event, label=null) {
      console.log('EVENT!!!', $event)
    },
    changeVenue(slide, $event) {
      this.ui.currentVenue = $event.currentSlide.index
      this.$refs['venueSlider_'+slide].forEach( (vRef) => {
        vRef.goToSlide( $event.currentSlide.index )
      })
    }
    

    
  }
}




// WEBPACK FOOTER //
// ./scripts/components/KitBlocks/KitInspiration.vue